import React from 'react';
import { Link } from 'react-router-dom';
import { Video, ThumbsUp, Users } from 'lucide-react';
import AdSlot from '../AdSlot';

const YouTubeSidebar: React.FC = () => {
  const playlists = [
    'Blogger Tutorials',
    'WordPress Guides',
    'SEO Tips',
    'Design Inspiration',
    'Marketing Strategies',
  ];

  return (
    <aside className="space-y-6">
      {/* Channel Stats */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
        <h3 className="font-semibold text-gray-900 mb-3">Channel Stats</h3>
        <div className="space-y-3">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gradient-to-br from-sky-100 to-blue-100 rounded-lg flex items-center justify-center">
              <Users className="w-5 h-5 text-sky-500" />
            </div>
            <div>
              <div className="text-lg font-semibold text-gray-900">50K+</div>
              <div className="text-xs text-gray-500">Subscribers</div>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gradient-to-br from-sky-100 to-blue-100 rounded-lg flex items-center justify-center">
              <Video className="w-5 h-5 text-sky-500" />
            </div>
            <div>
              <div className="text-lg font-semibold text-gray-900">200+</div>
              <div className="text-xs text-gray-500">Videos</div>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gradient-to-br from-sky-100 to-blue-100 rounded-lg flex items-center justify-center">
              <ThumbsUp className="w-5 h-5 text-sky-500" />
            </div>
            <div>
              <div className="text-lg font-semibold text-gray-900">5M+</div>
              <div className="text-xs text-gray-500">Total Views</div>
            </div>
          </div>
        </div>
      </div>

      {/* Playlists */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
        <h3 className="font-semibold text-gray-900 mb-3">Popular Playlists</h3>
        <div className="space-y-2">
          {playlists.map((playlist) => (
            <a
              key={playlist}
              href="#"
              className="block px-3 py-2 text-sm text-gray-700 hover:text-sky-500 hover:bg-sky-50 rounded-lg transition-colors"
            >
              {playlist}
            </a>
          ))}
        </div>
      </div>

      <AdSlot slot="sidebar" />


      {/* Subscribe CTA */}
      <div className="bg-gradient-to-br from-red-50 to-pink-50 rounded-xl border border-red-200 p-6">
        <h3 className="font-semibold text-gray-900 mb-2">Subscribe Now</h3>
        <p className="text-sm text-gray-600 mb-4">
          Get notified about our latest tutorials and tips.
        </p>
        <a
          href="https://youtube.com"
          target="_blank"
          rel="noopener noreferrer"
          className="block w-full px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg text-sm font-medium text-center transition-colors duration-300"
        >
          Subscribe on YouTube
        </a>
      </div>
    </aside>
  );
};

export default YouTubeSidebar;